export const BULMA_COLORS = [
  { value: '', label: 'Default' },
  { value: 'is-primary', label: 'Primary' },
  { value: 'is-link', label: 'Link' },
  { value: 'is-info', label: 'Info' },
  { value: 'is-success', label: 'Success' },
  { value: 'is-warning', label: 'Warning' },
  { value: 'is-danger', label: 'Danger' }
];

export const BULMA_SIZES = [
  { value: '', label: 'Normal' },
  { value: 'is-small', label: 'Small' },
  { value: 'is-medium', label: 'Medium' },
  { value: 'is-large', label: 'Large' }
];

export const BULMA_STYLES = [
  { value: '', label: 'Default' },
  { value: 'is-rounded', label: 'Rounded' }
];

export const BULMA_STATES = [
  { value: '', label: 'Normal' },
  { value: 'is-hovered', label: 'Hovered' },
  { value: 'is-focused', label: 'Focused' },
  { value: 'is-active', label: 'Active' },
  { value: 'is-loading', label: 'Loading' }
];

export const FONT_FAMILIES = [
  { value: 'inherit', label: 'Inherit' },
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Helvetica, sans-serif', label: 'Helvetica' },
  { value: "'Times New Roman', serif", label: 'Times New Roman' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: "'Courier New', monospace", label: 'Courier New' },
  { value: 'Verdana, sans-serif', label: 'Verdana' }
];

export const POSITION_OPTIONS = [
  { value: 'relative', label: 'Relative' },
  { value: 'absolute', label: 'Absolute' }
];

export const ICON_POSITIONS = [
  { value: 'left', label: 'Left' }
];

export const UNIT_OPTIONS = ['px', '%'];

export const DEFAULT_PROPS = {
  name: "",
  qwantumId: "",
  value: "",
  selectName: "",
  placeholder: "Select an option",
  allowEditing: true,
  options: [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" }
  ],
  bulmaSize: "",
  bulmaColor: "",
  bulmaStyle: "",
  bulmaState: "",
  isMultiple: false,
  multipleSize: 8,
  hasIcon: false,
  iconClass: "fas fa-globe",
  iconPosition: "left",
  labelText: "",
  labelFontSize: 14,
  showSemicolon: true,
  labelBold: true,
  labelItalic: false,
  fontFamily: "inherit",
  width: "100%",
  maxWidth: null,
  minWidth: null,
  flex: null,
  flexGrow: null,
  flexShrink: null,
  flexBasis: null,
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  unit: 'px',
  lockedEdges: { top: false, left: false, right: false, bottom: false },
  backgroundColor: '',
  borderRadius: 0,
  padding: 0,
  cssClass: '',
  selectClass: ''
};